import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { observer } from 'mobx-react-lite';
import { Box, Grid, Button, Typography, Stack, } from '@mui/material';
import { useStore, useTokens } from '@mcn-platform/models';
import UploadViewImage from '../common/asset/UploadViewImage';
import capitalizeFirstLetter from '../common/capitalizeFirstLetter';
import PhoneField from '../form/PhoneField';
import TextField from '../form/TextField';
const MyAccountForm = () => {
    const store = useStore();
    const tokens = useTokens();
    const organization = store.currentOrganization;
    const additionalFields = organization.signUpFields || [];
    const requiredFields = organization.signUpRequiredFields || [];
    const navigate = useNavigate();
    const { currentCustomer } = store;
    const [isChanged, setDisabled] = useState(false);
    const { handleSubmit, control, watch } = useForm({
        mode: 'onChange',
        defaultValues: {
            title: currentCustomer?.title,
            headline: currentCustomer?.headline,
            background: currentCustomer?.background,
            // name: currentCustomer?.name,
            // phoneNumber: currentCustomer?.phoneNumber,
            ...additionalFields.reduce((acc, field) => {
                acc[field] = currentCustomer[field];
                return acc;
            }, {}),
        },
    });
    const onSubmit = (data) => {
        setDisabled(false);
        console.log('onSubmit:', {
            data,
            currentCustomer,
        });
        currentCustomer.updateValues(data);
        // Update the store with the updated customer data
        store.update('customer', currentCustomer);
    };
    const signOut = () => {
        store.logoutCustomer().then(() => {
            navigate('.');
        });
    };
    useEffect(() => {
        const subscription = watch(() => {
            setDisabled(true);
        });
        return () => subscription.unsubscribe();
    }, [currentCustomer, watch]);
    return (_jsx(Box, { sx: { width: '100%' }, children: _jsxs("form", { autoComplete: "off", onSubmit: handleSubmit(onSubmit), children: [_jsxs(Grid, { container: true, spacing: 3, sx: { alignItems: 'center' }, children: [_jsx(Grid, { item: true, md: 6, sm: 8, xs: 12, children: _jsxs(Stack, { direction: "column", spacing: 2, sx: { width: '100%' }, children: [_jsx(Typography, { variant: "subtitle1", fontWeight: 700, sx: { mb: '3px' }, children: "User Account" }), _jsx(Typography, { variant: "h6", sx: { mb: 3, color: '#007bad' }, children: currentCustomer.email }), additionalFields.map((field) => {
                                        if (field === 'phoneNumber') {
                                            return (_jsx(PhoneField, { label: tokens.getToken(`customer${capitalizeFirstLetter(field)}Label`), name: field, control: control, required: requiredFields.includes(field) }, field));
                                        }
                                        return (_jsx(TextField, { label: tokens.getToken(`customer${capitalizeFirstLetter(field)}Label`), name: field, control: control, required: requiredFields.includes(field) }, field));
                                    }), _jsx(TextField, { label: "Title", name: "title", control: control }), _jsx(TextField, { label: "My Headline", name: "headline", control: control }), _jsx(TextField, { label: "Background", name: "background", control: control })] }) }), _jsx(Grid, { item: true, md: 2, sx: { display: { xs: 'none', md: 'block' } } }), _jsx(Grid, { item: true, md: 4, sm: 4, xs: 12, sx: { textAlign: 'center' }, children: _jsx(UploadViewImage, { repository: store.currentRepository, asset: currentCustomer?.profileImage, onAssetChange: (asset) => {
                                    console.log('setting profile image:', asset);
                                    currentCustomer?.updateValues({ profileImage: asset });
                                    setDisabled(true);
                                }, uploadPrefix: `public/profile/${currentCustomer.id}` }) })] }), _jsxs(Stack, { direction: "row", spacing: 2, sx: {
                        my: 3,
                    }, children: [_jsx(Button, { type: "submit", className: "site-system-button-primary", disabled: !isChanged, children: "Save" }), _jsx(Button, { onClick: signOut, className: "site-system-button-secondary", children: "Sign out" })] })] }) }));
};
export default observer(MyAccountForm);
//# sourceMappingURL=MyAccountForm.js.map